import React from "react";
import { View, StyleSheet, Modal } from "react-native";
import CustomText from "../../../components/common/general/CustomText/CustomText";
import LottieView from "lottie-react-native";
import AiTutorCompletionLottie from "../../../assets/lottie/progress/aiTutorCompletionLottie.json";
import CustomSpacing from "../../../components/common/layout/CustomSpacing/CustomSpacing";
import CustomButton from "../../../components/common/general/CustomButton/CustomButton";

const AssessmentCompleteModal = ({ visible, onConfirm }) => {
  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={visible}
      role="dialog"
      aria-modal="true"
      aria-label="completion modal">
      <View style={styles.centeredView}>
        <View style={styles.modalView}>
          <LottieView autoPlay loop={false} source={AiTutorCompletionLottie} style={styles.image} />
          <CustomSpacing type="vertical" size="xs" />
          <CustomSpacing type="vertical" size="xxl" />
          <CustomText
            aria-level="1"
            text="Assessment Completed!"
            size="xxl"
            weight="ultraBold"
            style={{ color: "#101828", textAlign: "center" }}
          />
          <CustomSpacing type="vertical" size="l" />
          <CustomText
            text="You’ve finished the assessment. Your responses have been recorded, and your instructor will review your performance."
            size="l"
            weight="normal"
            style={{ color: "#344054", textAlign: "center" }}
          />
          <CustomSpacing type="vertical" size="xs" />
          <CustomSpacing type="vertical" size="xxl" />
          <View style={styles.buttonBox}>
            <CustomButton
              aria-label="Exit Assessment"
              text="Exit Assessment"
              onPress={onConfirm}
              styleType="primary"
              style={styles.exitButton}
              textStyle={{ fontWeight: "700", fontSize: 18, fontFamily: "Inter" }}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  modalView: {
    borderRadius: 40,
    padding: 40,
    height: "auto",
    maxWidth: 688,
    width: "auto",
    backgroundColor: "white",
    alignItems: "center",
  },
  exitButton: {
    backgroundColor: "#3E68FE",
    padding: 16,
    borderRadius: 8,
  },
  buttonBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    gap: 16,
  },
  image: {
    width: 241,
    height: 215,
    backgroundColor: "#fff",
    justifyContent: "center",
    alignItems: "center",
  },
});

export default AssessmentCompleteModal;
